import { cn } from "@omni/utils/styles";
import React from "react";

import { PopOver } from "../PopOver/popOver.component";

export type TooltipProps = {
    innerHTML?: string;
    title?: string;
    className?: string;
    children?: React.ReactNode;
};

const Tooltip = ({ innerHTML, title, className, children }: TooltipProps) => {
    return (
        <PopOver
            dismissable={true}
            title={title}
            innerHTML={innerHTML}
            anchorComponent={(
                setReference,
                getReferenceProps,
                popOverComponent
            ) => (
                <span className={cn(className)}>
                    <i
                        ref={setReference}
                        className={cn(
                            "tw:align-middle tw:ml-1 tw:relative las la-info-circle",
                            "tw:after:content-[''] tw:after:absolute tw:after:w-6 tw:after:h-6 tw:after:cursor-pointer",
                            "tw:after:top-[calc(50%-12px)] tw:after:left-[calc(50%-12px)]"
                        )}
                        {...getReferenceProps()}
                    />
                    {popOverComponent()}
                </span>
            )}
        >
            {children}
        </PopOver>
    );
};

export { Tooltip };
